import { SPENDING_CATEGORIES } from './CurrentDocument';


export default SPENDING_CATEGORIES;
